import React from "react";
import { useTranslation } from "react-i18next";
import VideoUpload from "../inputs/video-upload";
import RichTextInput from "../inputs/rich-text-input";
import SelectExerciseTypeMuscleGroups from "../inputs/select-exercise-type-muscle-groups";
import {
  EXERCISE_TYPE,
  PRIMARY_MUSCLE_GROUP,
  SECONDARY_MUSCLE_GROUP,
} from "../../constants";

function ExtraInputComponent({
  videoUrl,
  videoFile,
  videoOriginal,
  cleanVideoField,
  handleInputChange,
  exerciseTypeField,
  primaryMuscleGroup,
  secondaryMuscleGroup,
  instructions,
  form,
  overlay = false,
}) {
  const { t } = useTranslation("coaching-portal");
  return (
    <>
      <div className="form-row">
        <div className="form-row-item">
          <label>{t("extraInput.exerciseType")}</label>
          <SelectExerciseTypeMuscleGroups
            value={exerciseTypeField}
            handleChange={handleInputChange}
            type={EXERCISE_TYPE}
            form={form ? form : ""}
            overlay={overlay}
          />
        </div>

        <div className="form-row-item">
          <label>{t("extraInput.primaryMuscleGroup")}</label>
          <SelectExerciseTypeMuscleGroups
            value={primaryMuscleGroup}
            handleChange={handleInputChange}
            type={PRIMARY_MUSCLE_GROUP}
            form={form ? form : ""}
            overlay={overlay}
          />
        </div>

        <div className="form-row-item">
          <label>{t("extraInput.secondaryMuscleGroup")}</label>
          <SelectExerciseTypeMuscleGroups
            value={secondaryMuscleGroup}
            handleChange={handleInputChange}
            type={SECONDARY_MUSCLE_GROUP}
            form={form ? form : ""}
            overlay={overlay}
          />
        </div>
      </div>
      <VideoUpload
        videoUrl={videoUrl}
        videoFile={videoFile}
        videoOriginal={videoOriginal}
        cleanVideoField={cleanVideoField}
        handleInputChange={handleInputChange}
        form={form ? form : ""}
      />

      <div className="form-row">
        <div className="form-row-item">
          <label>{t("extraInput.instructions")}</label>
          <RichTextInput
            value={instructions}
            name="instructions"
            handleInputChange={handleInputChange}
            form={form ? form : ""}
          />
        </div>
      </div>
    </>
  );
}

export default ExtraInputComponent;
